import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Icon from "material-ui/Icon";
import Typography from "material-ui/Typography";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import FiberLengthLoss from '../../../../subtestsetting/fiberlengthloss'

import { ModalHeader, ModalContents } from "../../../../common/modal";

class FiberLengthLossEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editSaving: false,
      errors: {},
      selected: {},
      error: null,
      modalOpen: false,
      showTestCreationCancelConfirmation: false
    };
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    this.props.handleClose(this.props.selectedTest)
  }

  testCreationClose = () => {
    this.setState({ showTestCreationCancelConfirmation: true })
  }

  onTestCreationCancelConfirm = () => {
    this.props.handleClose(this.props.selectedTest)
  }

  hideTestCreationCancelConfirm = () => {
    this.setState({ showTestCreationCancelConfirmation: false })
  }

  selectedRows = rows => {
    this.setState({
      selected: rows
    });
  };
  render() {
    const { translate, classes, selectedTest, fiberLengthLoss, getFiberLengthLoss, updateFiberLengthLoss, lengthMeasurementUnit,
      fiberlengthlossDetails, deleteDefaultSubtests, customerId, testEdit, modified } = this.props;
    const { showTestCreationCancelConfirmation } = this.state
    return (
      selectedTest && selectedTest.length ? (<Modal open={true} onClose={this.handleClose} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography
                type="headline"
                color="inherit"
                className={classes.modalHeader}
              >
                {testEdit ? translate("test_edit_title").toUpperCase(): translate("test_add").toUpperCase()}
              </Typography>
              <Button className={classes.close} onClick={this.testCreationClose}>
                <Icon> clear </Icon>
              </Button>
            </ModalHeader>
            <Typography
              type="headline"
              color="inherit"
              className={classes.modalHeader}
              style={{ marginLeft: '20px' }}
            >
              {translate("fiberlengthloss_setup")}
            </Typography>
            <ModalContents className={classes.rootModal}>
              <FiberLengthLoss
                selectedTest={selectedTest}
                fiberLengthLoss={fiberLengthLoss}
                translate={translate}
                getFiberLengthLoss={getFiberLengthLoss}
                updateFiberLengthLoss={updateFiberLengthLoss}
                lengthMeasurementUnit={lengthMeasurementUnit}
                handleClose={this.handleClose}
                isTestEdit={true}
                fiberlengthlossdetails={fiberlengthlossDetails}
                deleteDefaultSubtests={deleteDefaultSubtests}
                showTestCreationCancelConfirmation={showTestCreationCancelConfirmation}
                onTestCreationCancelConfirm={this.onTestCreationCancelConfirm}
                hideTestCreationCancelConfirm={this.hideTestCreationCancelConfirm}
                customerId={customerId}
                testEdit={testEdit}
                modified={modified}
              />
            </ModalContents>
          </Paper>
        </div>
      </Modal>)
        : null
    );
  }
}

export default withStyles(styles)(FiberLengthLossEdit);
